import React, { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var DefaultErrorComponent = function (_Component) {
  inherits(DefaultErrorComponent, _Component);

  function DefaultErrorComponent() {
    classCallCheck(this, DefaultErrorComponent);
    return possibleConstructorReturn(this, (DefaultErrorComponent.__proto__ || Object.getPrototypeOf(DefaultErrorComponent)).apply(this, arguments));
  }

  createClass(DefaultErrorComponent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'error' },
        React.createElement(
          'div',
          null,
          'An Error Occurred'
        ),
        React.createElement(
          'div',
          null,
          this.error
        ),
        React.createElement(
          'div',
          null,
          this.info
        )
      );
    }
  }]);
  return DefaultErrorComponent;
}(Component);

var HoneyBadgerErrorBoundary = function (_Component2) {
  inherits(HoneyBadgerErrorBoundary, _Component2);

  function HoneyBadgerErrorBoundary(props) {
    classCallCheck(this, HoneyBadgerErrorBoundary);

    var _this2 = possibleConstructorReturn(this, (HoneyBadgerErrorBoundary.__proto__ || Object.getPrototypeOf(HoneyBadgerErrorBoundary)).call(this, props));

    _this2.state = {
      error: null,
      info: null,
      errorOccurred: false
    };
    return _this2;
  }

  createClass(HoneyBadgerErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({ errorOccurred: true, error: error, info: info });
      this.props.honeybadger.notify(error, { context: info });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.errorOccurred) {
        var ErrorComponent = this.props.ErrorComponent;

        return ErrorComponent ? React.createElement(ErrorComponent, this.state) : React.createElement(DefaultErrorComponent, null);
      } else {
        return this.props.children;
      }
    }
  }], [{
    key: 'getDerivedStateFromError',
    value: function getDerivedStateFromError(error) {
      return { errorOccurred: true, error: error };
    }
  }]);
  return HoneyBadgerErrorBoundary;
}(Component);

HoneyBadgerErrorBoundary.propTypes = {
  honeybadger: PropTypes.object,
  children: PropTypes.element,
  ErrorComponent: PropTypes.element || PropTypes.function
};

export default HoneyBadgerErrorBoundary;
//# sourceMappingURL=honeybadger-react.esm.js.map
